"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAIN_MAPPING = {
    prefix: 'chains',
    chainList: {
        path: ''
    },
    createChain: {
        path: ''
    },
    updateChain: {
        path: '',
        parameter: '/:id'
    },
    updateStatus: {
        path: '/updateStatus',
        parameter: '/:id'
    },
    deleteChain: {
        path: '/deleteChain',
        parameter: '/:id'
    },
    getChain: {
        path: '/getChain',
        parameter: '/:id'
    }
};
